import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#fafaf8]" data-testid="privacy-policy">
      <div className="sticky top-0 z-10 bg-white/80 backdrop-blur-md border-b border-gray-100">
        <div className="max-w-3xl mx-auto px-6 py-3 flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="text-gray-500 hover:text-gray-900"><ArrowLeft size={18} /></button>
          <h1 className="font-semibold text-gray-900">Privacy Policy</h1>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-6 py-10 prose prose-sm prose-gray">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Super Morsel - Privacy Policy</h2>

        <p>At Super Morsel, we value the trust you place in us. This Privacy Policy outlines how we collect, use, and protect your personal information when you use our website and services.</p>

        <h3 className="text-lg font-semibold mt-6 mb-2">1. Information We Collect</h3>
        <ul className="list-disc pl-5 space-y-1 text-sm text-gray-600">
          <li><strong>Personal Information:</strong> Name, email address, phone number, delivery address, and payment-related details.</li>
          <li><strong>Usage Data:</strong> Device type, browser type, IP address, pages visited, and interaction patterns.</li>
          <li><strong>Order Information:</strong> Past orders, preferences, and wallet transaction history.</li>
        </ul>

        <h3 className="text-lg font-semibold mt-6 mb-2">2. How We Use Your Information</h3>
        <ul className="list-disc pl-5 space-y-1 text-sm text-gray-600">
          <li>To process and deliver your orders.</li>
          <li>To manage your wallet and process payments.</li>
          <li>To send order updates, promotional offers, and service-related notifications.</li>
          <li>To improve our services, website, and user experience.</li>
          <li>To comply with legal requirements.</li>
        </ul>

        <h3 className="text-lg font-semibold mt-6 mb-2">3. Sharing of Information</h3>
        <p className="text-sm text-gray-600">We do not sell your personal information. We may share limited data with:</p>
        <ul className="list-disc pl-5 space-y-1 text-sm text-gray-600">
          <li>Delivery partners, to fulfill your orders.</li>
          <li>Payment processors, for secure transactions.</li>
          <li>Legal authorities, if required by law.</li>
        </ul>

        <h3 className="text-lg font-semibold mt-6 mb-2">4. Data Security</h3>
        <p className="text-sm text-gray-600">We implement industry-standard measures to protect your data. However, no digital platform can guarantee 100% security.</p>

        <h3 className="text-lg font-semibold mt-6 mb-2">5. Cookies</h3>
        <p className="text-sm text-gray-600">Our website uses cookies to enhance your browsing experience. You can manage cookie preferences through your browser settings.</p>

        <h3 className="text-lg font-semibold mt-6 mb-2">6. Your Rights</h3>
        <p className="text-sm text-gray-600">You may request to access, update, or delete your personal data by contacting our support team.</p>

        <h3 className="text-lg font-semibold mt-6 mb-2">7. Changes to this Policy</h3>
        <p className="text-sm text-gray-600">We may update this policy from time to time. Changes will be reflected on this page, and continued use of our services implies acceptance.</p>

        <h3 className="text-lg font-semibold mt-6 mb-2">8. Nutritional Information Disclaimer</h3>
        <p className="text-sm text-gray-600">
          Any nutritional information on the app pages is curated by our Registered Dietitian on the basis of ingredient data provided by the National Institute of Nutrition (NIN, India), U.S. Department of Agriculture, Agricultural Research Service – USDA National Nutrient Database for Standard Reference, and calculated with external recipe apps. The nutritional data provided is for informational purposes only.
        </p>
        <ul className="list-disc pl-5 mt-2 space-y-1 text-sm text-gray-600">
          <li>It is not intended to diagnose, treat, cure, or prevent any disease.</li>
          <li>It should not be used as a substitute for professional dietary, medical, or nutrition advice.</li>
          <li>Always consult a qualified healthcare provider before making significant changes to your diet or health plan.</li>
        </ul>

        <h3 className="text-lg font-semibold mt-6 mb-2">9. Contact Us</h3>
        <p className="text-sm text-gray-600">For any questions about this policy, reach out to us at <strong>hello@supermorsel.com</strong>.</p>

        <p className="text-[10px] text-gray-500 mt-8 border-t pt-4">Thank you for trusting Super Morsel with your data. We're committed to protecting your privacy while delivering a great food experience.</p>
      </div>
    </div>
  );
}
